import ShareableLinks from './ShareableLinks.page';

export default ShareableLinks;